import Options from './options.element.js';

export default Options;

Options.define('wje-options', Options);
